export default "__VITE_ASSET__CDWO51sN__"